import { I18nContext } from 'contexts/I18n/I18nProvider'
import { TFunction } from 'i18next'
import React, { useContext } from 'react'

type TitleProps = {
  minSignal: number | null
  maxSignal: number | null
  latestSignal: number | null
  score: number | null
}

function getdataLabel(data: number | null, t: TFunction) {
  return (!data && data !== 0) ? t('general.not_available') : `${data}%`
}

export default function Title({ minSignal, maxSignal, latestSignal, score }: TitleProps) {
  const t = useContext(I18nContext)
  return (
    <div>
      <h2 className='subtitle'>{t('wifi_dashboards.signal_strength')}</h2>
      <div className="wifi-display-flex">
        <div className="wifi-item">
          <div className="wifi-item-title">{t('wifi_dashboards.latest_signal_strength')}</div>
          <div className="wifi-item-value">{getdataLabel(latestSignal, t)}</div>
        </div>
        <div className="wifi-item">
          <div className="wifi-item-title">{t('wifi_dashboards.maximum_signal')}</div>
          <div className="wifi-item-value">{getdataLabel(maxSignal, t)}</div>
        </div>
        <div className="wifi-item">
          <div className="wifi-item-title">{t('wifi_dashboards.minimum_signal')}</div>
          <div className="wifi-item-value">{getdataLabel(minSignal, t)}</div>
        </div>
        <div className="wifi-item">
          <div className="wifi-item-title">{t('wifi_dashboards.score')}</div>
          <div className="wifi-item-value">{getdataLabel(score, t)}</div>
        </div>
      </div>
    </div>
  )
}
